<a cuiButton class="sidebar__entry" [active]="isDashboardActive()" routerLink="/dashboard">
  <span class="material-symbols-outlined">home</span>
  Home
</a>

@if (!historiesReady()) {
  <div class="sidebar__skeleton" aria-label="Loading navigation">
    @for (_ of [0, 1, 2, 3]; track $index) {
      <span
        class="cui-skeleton sidebar__skeleton-bar"
        aria-hidden="true"
        [style.opacity]="1 - $index * 0.2"></span>
    }
  </div>
} @else {
  @for (tool of tools.value() ?? []; track tool.toolId) {
    <cui-expandable-item
      #toolItem
      [itemId]="'tool-' + tool.toolId"
      [expanded]="isExpanded('tool-' + tool.toolId)"
      (expandedChange)="setExpanded('tool-' + tool.toolId, $event)">
      <a
        cuiButton
        class="sidebar__entry"
        [active]="isToolOverviewActive(tool.toolId)"
        [cuiExpandableItemTriggerFor]="toolItem"
        [cuiExpandableItemToggle]="isToolOverviewActive(tool.toolId)"
        [routerLink]="['/tools', tool.toolId]">
        <span class="material-symbols-outlined">widgets</span>
        <span class="sidebar__label">{{ tool.name }}</span>
        <span
          class="sidebar__chevron material-symbols-outlined"
          [class.sidebar__chevron--expanded]="toolItem.isExpanded()">
          keyboard_arrow_down
        </span>
      </a>
      @if (isToolNewRunActive(tool.toolId)) {
        <a
          cuiButton
          class="sidebar__child"
          [active]="true"
          [routerLink]="['/tools', tool.toolId, 'run']">
          New Run
        </a>
      }
      @if (isToolHistoryLoading(tool.toolId)) {
        <p class="sidebar__empty">Loading runs…</p>
      } @else {
        @for (run of runsForTool(tool.toolId); track run.id) {
          <a
            cuiButton
            class="sidebar__child"
            [active]="isToolRunActive(tool.toolId, run.id)"
            [routerLink]="['/tools', tool.toolId, 'results', run.id]">
            Tool Run #{{ run.id }}
          </a>
        } @empty {
          @if (!isToolNewRunActive(tool.toolId)) {
            <p class="sidebar__empty">No runs yet.</p>
          }
        }
      }
    </cui-expandable-item>
  }

  @for (toolchain of toolchains.value() ?? []; track toolchain.toolchainId) {
    <cui-expandable-item
      #toolchainItem
      [itemId]="'toolchain-' + toolchain.toolchainId"
      [expanded]="isExpanded('toolchain-' + toolchain.toolchainId)"
      (expandedChange)="setExpanded('toolchain-' + toolchain.toolchainId, $event)">
      <a
        cuiButton
        class="sidebar__entry"
        [active]="isToolchainOverviewActive(toolchain.toolchainId)"
        [cuiExpandableItemTriggerFor]="toolchainItem"
        [cuiExpandableItemToggle]="isToolchainOverviewActive(toolchain.toolchainId)"
        [routerLink]="['/toolchains', toolchain.toolchainId]">
        <span class="material-symbols-outlined">account_tree</span>
        <span class="sidebar__label">{{ getDisplayName(toolchain) }}</span>
        <span
          class="sidebar__chevron material-symbols-outlined"
          [class.sidebar__chevron--expanded]="toolchainItem.isExpanded()">
          keyboard_arrow_down
        </span>
      </a>
      @if (isToolchainNewRunActive(toolchain.toolchainId)) {
        <a
          cuiButton
          class="sidebar__child"
          [active]="true"
          [routerLink]="['/toolchains', toolchain.toolchainId, 'run']">
          New Run
        </a>
      }
      @if (isToolchainHistoryLoading(toolchain.toolchainId)) {
        <p class="sidebar__empty">Loading runs…</p>
      } @else {
        @for (run of runsForToolchain(toolchain.toolchainId); track run.id) {
          <a
            cuiButton
            class="sidebar__child"
            [active]="isToolchainRunActive(toolchain.toolchainId, run.id)"
            [routerLink]="['/toolchains', toolchain.toolchainId, 'results', run.id]">
            Toolchain Run #{{ run.id }}
          </a>
        } @empty {
          @if (!isToolchainNewRunActive(toolchain.toolchainId)) {
            <p class="sidebar__empty">No runs yet.</p>
          }
        }
      }
    </cui-expandable-item>
  }

  @if (isAdmin()) {
    <a cuiButton routerLink="/admin" [active]="isAdminActive()">
      <span class="material-symbols-outlined">admin_panel_settings</span>
      Admin Area
    </a>
  }
}
